import React, {useState} from 'react'

import {
  DateTimeField,
  FieldSpec,
  LinkedPathField,
  PaginatedTable,
  RelatedLinkedField,
  UnitLocUnitField,
  ValueField,
} from 'src/components/Table'
import {ListTableProps} from './types'
import {UnitLoc} from 'src/api/models'
import {ReportDamageDialog} from 'src/modules/supply_chain/components/ReportDamageDialog'
import {ReportLostDialog} from 'src/modules/supply_chain/components/ReportLostDialog'

const fieldOptions: {[key: string]: FieldSpec} = {
  productName: {id: 'sku.productName', label: 'Product Name', ordering: 'product__name', renderer: ValueField},
  product: {id: 'product', label: 'Product', ordering: 'product__name', renderer: RelatedLinkedField(ValueField, 'name')},
  sku: {id: 'sku', label: 'SKU', ordering: 'sku__sku', renderer: RelatedLinkedField(ValueField, 'name')},
  batch: {id: 'batch', label: 'Batch', ordering: 'client_uid', renderer: RelatedLinkedField(ValueField, 'name')},
  client: {
    id: 'sku.client',
    label: 'Client',
    ordering: 'sku__account__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  numUnits: {id: 'numUnits', label: 'Number of Units', ordering: 'num_units', renderer: UnitLocUnitField},
  dateReceived: {id: 'dateReceived', label: 'Date Units Received', ordering: 'date_received', renderer: DateTimeField},
  path: {id: 'objPath', label: 'Path', ordering: 'container__place__search_path,place__search_path', renderer: LinkedPathField},
}

export const UnitListTable = (props: ListTableProps) => {
  const {paginator, title, fields, exportConfig} = props
  const [unit, setUnit] = useState<UnitLoc | undefined>(undefined)
  const [damageOpen, setDamageOpen] = useState(false)
  const [lostOpen, setLostOpen] = useState(false)

  const damageClick = (unit: UnitLoc) => {
    setUnit(unit)
    setDamageOpen(true)
  }
  const lostClick = (unit: UnitLoc) => {
    setUnit(unit)
    setLostOpen(true)
  }

  return (
    <>
      {damageOpen && (
        <ReportDamageDialog
          open={damageOpen}
          handleClose={() => {
            setUnit(undefined)
            setDamageOpen(false)
          }}
          unit={unit}
          onSave={paginator.refresh}
        />
      )}
      {lostOpen && (
        <ReportLostDialog
          open={lostOpen}
          handleClose={() => {
            setUnit(undefined)
            setLostOpen(false)
          }}
          unit={unit}
          onSave={paginator.refresh}
        />
      )}
      <PaginatedTable
        title={title || 'Units'}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        rowActions={[{title: () => 'Mark Damaged', onClick: damageClick}, {title: () => 'Mark Lost', onClick: lostClick}]}
        exportConfig={exportConfig}
      />
    </>
  )
}
